import React from "react";
import { Box, Stack, Typography, Chip, useTheme, alpha } from "@mui/material";
import Lottie from "lottie-react";
import animationEmpty from "../../lottie/maintenance.json";
import { useTranslation } from "react-i18next";

function MaintainanceState() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 3,
        position: "relative",
      
      }}
    >
      {/* Central Glass Card Container */}
      <Stack
        alignItems="center"
        spacing={3}
        sx={{
          maxWidth: 440,
          width: "100%",
          p: { xs: 4, sm: 5 },
          borderRadius: 6,
          backgroundColor: isDark
            ? alpha("#1c1c1e", 0.65)
            : alpha("#ffffff", 0.75),
          backdropFilter: "blur(20px) saturate(180%)",
          WebkitBackdropFilter: "blur(20px) saturate(180%)",
          border: `1px solid ${
            isDark ? alpha("#ffffff", 0.08) : alpha("#000000", 0.06)
          }`,
          boxShadow: isDark
            ? "0 30px 60px rgba(0,0,0,0.4)"
            : "0 20px 40px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.02)",
          transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        {/* Lottie Graphic Container with Ambient Glow */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&::before": {
              content: '""',
              position: "absolute",
              width: 140,
              height: 140,
              borderRadius: "50%",
              background: theme.palette.primary.main,
              opacity: isDark ? 0.15 : 0.08,
              filter: "blur(30px)",
              zIndex: 0,
            },
          }}
        >
          <Lottie
            animationData={animationEmpty}
            loop
            style={{ width: 160, height: 160, zIndex: 1 }}
          />
        </Box>

        {/* System Status Indicator Pill */}
        <Chip
          label={t("maintenance:badge", "System Maintenance")}
          size="small"
          sx={{
            fontWeight: 600,
            fontSize: "0.75rem",
            letterSpacing: "0.02em",
            textTransform: "uppercase",
            borderRadius: 10,
            px: 1,
            py: 0.5,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.main,
            border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
          }}
        />

        {/* Messaging Stack */}
        <Stack spacing={1.5} alignItems="center" textAlign="center">
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: "text.primary",
            }}
          >
            {t("maintenance:line1")}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              lineHeight: 1.6,
              maxWidth: 320,
              fontSize: "0.9375rem",
              fontWeight: 400,
            }}
          >
            {t("maintenance:line2")}{" "}
            {t("maintenance:line3") && `${t("maintenance:line3")}`}
          </Typography>
        </Stack>

        {/* Status Footer */}
        <Typography
          variant="caption"
          sx={{
            color: "text.disabled",
            fontWeight: 500,
            letterSpacing: "-0.01em",
            pt: 1,
          }}
        >
          {t("maintenance:thanks")}
        </Typography>
      </Stack>
    </Box>
  );
}

export default MaintainanceState;